import { Box, CircularProgress } from '@mui/material';
import { useTheme } from "@mui/material/styles";
import { GridBox, GridNoRowsOverlay, CentralDataGridPro } from 'components/shared/grids';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import useTaskProblemLogColumns from './useTaskProblemLogColumns';
import { useSnackbar } from '@sagecentral/core-ui';

export interface ITaskProblemGridProps {
    problems: any[];
    hasAddProblemFlagPermission: boolean;
    hasRemoveProblemFlagPermission: boolean;
    isTaskCompleted: boolean;
    onUpdateProblem: (problemLogId: number, resolution: boolean, problemDescription?: string) => void;    
}

const NoRowsOverlay = () => {
    return (
        <GridNoRowsOverlay text={`No problems found.`} />
    );
};

const TaskProblemGrid = (props: ITaskProblemGridProps) => {
    const { problems, onUpdateProblem, hasAddProblemFlagPermission, hasRemoveProblemFlagPermission, isTaskCompleted } = props;
    const theme = useTheme();
    const apiRef = useGridApiRef();
    const { displaySnackbar } = useSnackbar();

    const [columnsModel] = useTaskProblemLogColumns(onUpdateProblem, hasAddProblemFlagPermission, hasRemoveProblemFlagPermission, isTaskCompleted);
    const getData = () => (problems && problems.length > 0 ? problems : []);

    const updateField = (newRow: any, oldRow: any) => {        
        if(newRow.note === oldRow.note)
        return;
    
        if (newRow.note === '' || newRow.note === null) {
            return oldRow;
        }
        else if (newRow.note.length > 300) {
            displaySnackbar('error', 'Allows maximum 300 characters.')
            return oldRow;
        }

        var resolution = newRow.note === oldRow.note ? oldRow.isProblemResolved : false;
        newRow.isProblemResolved = resolution;
        onUpdateProblem(newRow.id, resolution, newRow.note);
        return newRow;
    }
    
    return (
        <Box sx={{maxWidth: '60vw'}}>
            {problems && problems.length > 0 &&
            <GridBox getData={getData}>
            <Box>
                        <CentralDataGridPro
                            getRowHeight={() => 'auto'}
                            apiRef={apiRef}
                            rows={getData()}
                            columns={columnsModel}
                            processRowUpdate={updateField}
                            hideFooter={true}
                            autoHeight={true}
                            getRowId={(r) => r.id}
                            density={'standard'}
                            slotProps={{
                                root: {
                                    'aria-label': 'Task Problems Grid',
                                    'tabIndex': 8
                                }
                            }}
                            slots={{
                                loadingOverlay: () => (<CircularProgress/>),
                                noRowsOverlay: () => NoRowsOverlay(),
                            }}
                            getRowClassName={(params) =>
                                params.indexRelativeToCurrentPage % 2 === 0 ? 'row even' : 'row odd'
                            }
                            disableRowSelectionOnClick
                            disableColumnFilter
                            disableColumnMenu
                            />
                </Box>
            </GridBox> || <></>}
        </Box>
    )
};

export default TaskProblemGrid;
